import { render, staticRenderFns } from "./CaseDetailFooter.vue?vue&type=template&id=58ff211c"
import script from "./CaseDetailFooter.vue?vue&type=script&lang=js"
export * from "./CaseDetailFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports